// import { ReactComponent as ArrowRightSVG } from 'assets/icon-arrow-right.svg';
import { ReactComponent as AvatarSVG } from 'assets/icon-avatar.svg';
import Tabs, { Tab } from 'components/Tabs';
import { useContext, useEffect, useState } from 'react';
import { Link, useLocation, Outlet, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { useAuth } from 'context/Auth'; 
import { GlobalContext4User } from '../../storage/user';
import { countRentDataLogs } from '../../api/logs'; 
import { listPendingFamiShipments, PendingFamiShipment } from 'api/fmeReturnship';
import { famiDeadlineText } from 'pages/Rent/FamiShipQr';
// import { format as dateFormat } from 'date-fns'; 
import Dialog from 'components/Dialog'; 
import { useGlobalError } from 'context/Error/GlobalErrorContext';

// Test cache

const MemberCenter = () => {
  const { accessToken, me } = useAuth(); // 22.04.22 SCH
  const [activeTab, setActiveTab] = useState<number>(1);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // @ts-ignore 
  const { meUserStorage } = useContext(GlobalContext4User);
  /* eslint-disable */
  const { user, user_role, user_type } = meUserStorage; // 22.11.23 SCH
  const [visible4set, setVisible4set] = useState<boolean>(false); // 22.11.23 SCH
  const [logs, setLogs] = useState<{
    count4using: number; count4expired: number; count4all: number; count4return: number;}>
    ({count4using: 0, count4expired: 0, count4all: 0, count4return: 0});
  // PG-209 還沒去全家交件的寄件單 → 橫幅提醒,點進歸還紀錄重看 QR
  const [pendingFami, setPendingFami] = useState<PendingFamiShipment[]>([]);
  useEffect(() => {
    if (!me) return;
    listPendingFamiShipments()
      .then(setPendingFami)
      .catch(() => setPendingFami([]));
    // eslint-disable-next-line
  }, [me]);
  /* eslint-enable */
  const [imgUrl, setImgUrl] = useState<string>(''); // 22.07.07 SCH
  const imgPreUrl = 'https://packageplusmainsys.s3-ap-northeast-1.amazonaws.com/';
  const { showError } = useGlobalError()

  useEffect(() => {
    fetchRentDataLogs('all'); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
    
  useEffect(() => {
    // fetchRentDataLogs('all');
    // setActiveTab(1);
    if (pathname.indexOf('return') !== -1) {
      setActiveTab(1);
    } else if (pathname.indexOf('payment') !== -1) {
      setActiveTab(2);
    } else {
      setActiveTab(0);
    }
    // consoleLog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(()=>{
    setupImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user]);

  const fetchRentDataLogs = async (filter: string) => {
    try {
      const { data } = await countRentDataLogs(
        accessToken!,
        1,
        me?.id!,
        filter
      );
      if (!data) {
        return 'Have not any rent logs !!';
      } else {
        
        setLogs({count4using: data.count4using, 
          count4expired: data.count4expired, 
          count4all: data.count4all, 
          count4return: data.count4return
        });
      }
      setupImage()
    } catch (e: any) {
      console.log(e)
      showError(e, 'error')
    }
  };

  const setupImage = () => {
    if (user.photo_url && user.photo_url.length > 9) {
      if (user.photo_url.indexOf('http') < 0) {
        setImgUrl(imgPreUrl + user.photo_url);
      } else {
        setImgUrl(user.photo_url);
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const onConfirm = () => {
    setVisible4set(false);
  };
  const onCancel = () => {
    setVisible4set(false);
  };
  

  return (
    <div className={styles.memberCenter}>
      <div className={styles.header}>
        <div className={styles.info}>
          <div
            className={styles.avatar}
            onClick={() => {
              navigate('profile');
            }}
          >
            {imgUrl.length <= 9 ? (
              <AvatarSVG />
            ) : (
              <img src={imgUrl} height="40" alt="" />
            )}
          </div>
          <div className={styles.detail}>
            <h5
              onClick={() => {
                navigate('profile');
              }}
            >
              {/* {me?.mobile_number} 22.04.21 SCH */}
              {user.realname !== '' ? user.realname : user.mobile_number}
            </h5>

            <div className={styles.extra}>
              <span>{user.mobile_number}</span>
            </div>
            {/* <div className={styles.extra}>
              <span>配客嘉會員</span>
              <button>
                <span>方案說明</span>
                <ArrowRightSVG />
              </button>
              <button
                onClick={() => {
                  (user.role > 1) ?
                    navigate('/payment/member') 
                    : setVisible4set(false)
                 }} >
                <span>付款設定</span>
                <ArrowRightSVG />
              </button>
            </div> */}
          </div>
        </div>
        {/* <div className={styles.additionInfo}>
          <span>循環購物袋</span>
          <div className={styles.comingSoon}>
            <span>Coming soon</span>
          </div>
        </div> */}
        <div className={styles.additionInfo}>
          <div className={styles.usageInfo}>
            <div className={styles.column}>
              <span className={styles.num}>{logs.count4using}</span>
              <span>使用中</span>
            </div>
            <div className={styles.column}>
              <span className={styles.num}>{logs.count4expired}</span>
              <span>已逾期</span>
            </div>
            <div className={styles.column}>
              <span className={styles.num}>{logs.count4return}</span>
              <span>已歸還</span>
            </div>
          </div>
        </div>
      </div>
      {pendingFami.length > 0 && (
        <div
          onClick={() => navigate('return')}
          style={{
            margin: '10px 16px 0',
            padding: '10px 14px',
            background: '#fff6e5',
            border: '1px solid #f0ad4e',
            borderRadius: 10,
            fontSize: 13,
            lineHeight: 1.6,
            color: '#7a4e00',
            cursor: 'pointer',
          }}
        >
          <b>您有 {pendingFami.length} 筆全家歸還尚未交件</b>
          <br />
          寄件編號 {pendingFami.map((p) => p.order_no).join('、')}
          <br />
          {famiDeadlineText(pendingFami[0].expires_at)},點此查看 QR 與交件步驟 ›
        </div>
      )}
      <div className={styles.tabContainer}>
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label="租借記錄" component={Link} to={`./`} />
          <Tab label="歸還記錄" component={Link} to={`return`} />
          <Tab
            disabled={true}
            label="扣款記錄"
            component={Link}
            to={`payment`}
          />
        </Tabs>
      </div>
      <div className={styles.container}>
        <Outlet />
      </div>

      <Dialog
        visible={visible4set}
        onConfirm={onConfirm}
        onCancel={onCancel}
        message={
          <div className={styles.dialogHeader}>
            <h3>
              {(user.role > 1)
                ? '符合開放條件'
                : '尚未開放設定'}
            </h3>
            <p>... 功能測試中 ... </p>
          </div>
        }
        cancelText={'Exit'}
        okText={'知道了'}
        cancelable={true}
      />
   </div>
  );
};

export default MemberCenter;
